module.exports = __webpack_public_path__ + "af2b8501653dbcd68143c1d52da112cb.png";